import axios from '@/plugins/axios'

export default {
  async LOAD_DASHBOARD ({ commit, state }) {
    return new Promise((resolve, reject) => {
      const data = {
        headers: {
          Authorization: 'Bearer ' + state.access_token
        }
      }
      commit('loading')
      axios.get('dashboard', data).then((response) => {
        commit('loadingFail')
        resolve(response)
      }).catch(error => {
        commit('loadingFail')
        reject(error)
      })
    })
  }
}
